import { render, staticRenderFns } from "./UploadLoanAndCollectionOfficer.vue?vue&type=template&id=695521b8&scoped=true&"
import script from "./UploadLoanAndCollectionOfficer.vue?vue&type=script&lang=js&"
export * from "./UploadLoanAndCollectionOfficer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "695521b8",
  null
  
)

export default component.exports